// extracted by mini-css-extract-plugin
export default {"outerСircle":"m0xvJ","innerСircle":"kPslT","order":"q5IIO"};